/**
 * @generated SignedSource<<11c6bd9e2ce835ce3660f84ec2683224>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CopilotSettingsUserFilterQuery$variables = {
  query?: string | null;
};
export type CopilotSettingsUserFilterQuery$data = {
  readonly selectUsers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly email: string;
        readonly " $fragmentSpreads": FragmentRefs<"CopilotSettingsUserFilterUserOption">;
      };
    }>;
  } | null;
};
export type CopilotSettingsUserFilterQuery = {
  response: CopilotSettingsUserFilterQuery$data;
  variables: CopilotSettingsUserFilterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "isGuests",
    "value": false
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "query"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CopilotSettingsUserFilterQuery",
    "selections": [
      {
        "alias": "selectUsers",
        "args": (v1/*: any*/),
        "concreteType": "UserConnection",
        "kind": "LinkedField",
        "name": "users",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CopilotSettingsUserFilterUserOption"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CopilotSettingsUserFilterQuery",
    "selections": [
      {
        "alias": "selectUsers",
        "args": (v1/*: any*/),
        "concreteType": "UserConnection",
        "kind": "LinkedField",
        "name": "users",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "image",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isGuest",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserInternalAttributes",
                    "kind": "LinkedField",
                    "name": "internalAttributes",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserConnection",
                        "kind": "LinkedField",
                        "name": "allReports",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1a02173e0174ba7f36f0407b31f1d02f",
    "id": null,
    "metadata": {},
    "name": "CopilotSettingsUserFilterQuery",
    "operationKind": "query",
    "text": "query CopilotSettingsUserFilterQuery(\n  $query: String\n) {\n  selectUsers: users(first: 10, search: $query, isGuests: false) {\n    edges {\n      node {\n        email\n        ...CopilotSettingsUserFilterUserOption\n        id\n      }\n    }\n  }\n}\n\nfragment CopilotSettingsUserFilter on User {\n  id\n  email\n  image\n  fullName\n  isGuest\n}\n\nfragment CopilotSettingsUserFilterUserOption on User {\n  id\n  email\n  image\n  fullName\n  isGuest\n  ...CopilotSettingsUserFilter\n  ...UserSelectionStepGetIncludesString\n  ...RuleConfigurationStepUserPill\n}\n\nfragment RuleConfigurationStepUserPill on User {\n  id\n  fullName\n  image\n  isGuest\n  email\n}\n\nfragment UserSelectionStepGetIncludesString on User {\n  fullName\n  internalAttributes {\n    allReports {\n      edges {\n        node {\n          fullName\n          id\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5ccd1c963b365d2e4b7b36c6d7636a6a";

export default node;
